import React, { useState, useRef, useEffect } from "react";
import * as Icons from "../../assets/SVGs/index";
import LogoutButton from "../logout-button";
import { UserMenuProps } from "../../types/user-menu";
import { useSelector } from "react-redux";
import { RootState } from "../../state-management/store";
import theme from "../../config/theme";
import { useNavigate } from "react-router-dom";
import { NotificationsButton } from "../notifications";

const UserMenu: React.FC<UserMenuProps> = ({
  username,
  isCollapsed,
  avatarUrl,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const themeMode = useSelector((state: RootState) => state.globalState.theme);
  const mode = themeMode === "light" ? theme.light : theme.dark;

  const goToPage = (url: string) => {
    navigate(url);
    setIsMenuOpen(false);
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative flex items-center space-x-4" ref={menuRef}>
      <NotificationsButton />

      {/* Username */}
      <span className="text-sm font-medium text-gray-700 ml-3">{username}</span>

      {/* Avatar */}
      {avatarUrl ? (
        <div onClick={toggleMenu} className="cursor-pointer">
          <img
            src={avatarUrl}
            alt="personal_picture"
            style={{
              width: 60,
              height: 60,
              borderRadius: "50%",
              border: "2px solid white",
            }}
          />
        </div>
      ) : (
        <div onClick={toggleMenu} className="cursor-pointer">
          <Icons.AvatarIcon className="w-12 h-12 rounded-full border border-[#D8D8D8]" />
        </div>
      )}

      {/* Dropdown Menu */}
      {isMenuOpen && (
        <div
          className="absolute left-0 top-[118%] w-48 bg-white shadow-md rounded z-10 m-0"
          style={{
            backgroundColor: mode.backgroundColor.bgSecondary,
            color: mode.color.textPrimary,
          }}
        >
          <ul className="px-2 py-5 text-right">
            <li
              className="px-3 py-2 text-gray-700 hover:bg-gray-100 cursor-pointer flex justify-start"
              onClick={() => goToPage("/profile")}
            >
              <Icons.UserIcon className="w-6 h-6 ml-2" />
              پروفایل
            </li>
            <li
              className="px-3 py-2 text-gray-700 hover:bg-gray-100 cursor-pointer flex justify-start"
              onClick={() => goToPage("/change-password")}
            >
              <Icons.ChangePassIcon className="w-6 h-6 ml-2" />
              تغییر رمز ورود
            </li>
            <li className="px-3 py-2 text-gray-700 hover:bg-gray-100 cursor-pointer flex justify-start">
              <LogoutButton isCollapsed={isCollapsed} />
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default UserMenu;
